<script lang="ts">
    import {
        RadioGroup,
        RadioGroupLabel,
        RadioGroupOption,
    } from '@rgossiaux/svelte-headlessui';
    import type {SelectableItem} from './types';
    import {createEventDispatcher} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let items: SelectableItem[];

    const dispatch = createEventDispatcher<{select: SelectableItem}>();

    let selectedItem: SelectableItem = null;

    $: if (exists(selectedItem)) {
        dispatch('select', selectedItem);
    }
</script>

<RadioGroup bind:value={selectedItem}>
    {#each items as item(item.id)}
        <RadioGroupOption class="selectable-item" value={item}>
            <RadioGroupLabel as="span" class="sr-only">{item.text}</RadioGroupLabel>
            <div class="inert-content">
                <slot {item}></slot>
            </div>
        </RadioGroupOption>
    {/each}

</RadioGroup>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    :global {
        .selectable-item {
            touch-action: manipulation;
            cursor: pointer;

            .panel {
                background: transparent;
            }

            &:hover,
            &:focus {
                background-color: @list-group-hover-bg;
            }
        }
    }

    .inert-content {
        pointer-events: none; // disables click and similar action on element and its descendants
    }
</style>